import React from 'react';
import PropTypes from 'prop-types';
import _, { get } from 'lodash';
import emptyList from 'assets/images/icons/empty-list.svg';
import cn from 'classnames';

function List({
  data,
  render,
  isLoading,
  selectedId,
  onSelectRow,
  itemClassName,
  linkClassName,
  containerClassName,
  selectedKey,
}) {
  const checkDataType = (item) => {
    try {
      if (typeof render === 'string') return _.get(item, render);
      if (typeof render === 'function') return render(item);
      return '-';
    } catch (err) {
      return '- ERR -';
    }
  };

  const handleSelectItem = (e, item) => {
    e.preventDefault();
    onSelectRow(item);
  };

  return (
    <ul className={cn('w-64 space-y-3 flex-grow', containerClassName)}>
      {isLoading || (data || [])?.length < 1 ? (
        <div className={cn(isLoading ? 'h-auto' : 'h-full')}>
          {isLoading ? (
            <div className="grid grid-cols-2 gap-3 p-3">
              <div className="col-span-2 animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="col-span-2 animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="col-span-2 animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="col-span-2 animate-pulse bg-gray-200 h-8 w-full rounded" />
              <div className="col-span-2 animate-pulse bg-gray-200 h-8 w-full rounded" />
            </div>
          ) : (
            <div className="h-full flex justify-center items-center text-gray-500">
              <div className="flex flex-col items-center">
                <img src={emptyList} alt="empty" className="mb-4" />
                <div className="font-bold">Empty</div>
                <div>There are no items.</div>
              </div>
            </div>
          )}
        </div>
      ) : (
        (data || [])?.map((item) => (
          <li
            key={get(item, selectedKey)}
            onClick={(e) => handleSelectItem(e, item)}
            className={cn(
              'transition rounded-sm list-none duration-200 cursor-pointer',
              selectedId === get(item, selectedKey)
                ? 'bg-gray-400 '
                : 'bg-white hover:bg-gray-100',
              itemClassName,
            )}
            aria-hidden="true"
          >
            <a
              href="/"
              className={cn(
                'hover:no-underline',
                selectedId === get(item, selectedKey)
                  ? 'text-white hover:text-white'
                  : ' text-gray-500',
                linkClassName,
              )}
            >
              {checkDataType(item)}
            </a>
          </li>
        ))
      )}
    </ul>
  );
}

List.defaultProps = {
  containerClassName: '',
  itemClassName: '',
  linkClassName: '',
  selectedId: '',
  isLoading: false,
  render: 'id',
  selectedKey: 'uuid',
};

List.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
  itemClassName: PropTypes.string,
  linkClassName: PropTypes.string,
  onSelectRow: PropTypes.func.isRequired,
  containerClassName: PropTypes.string,
  selectedId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isLoading: PropTypes.bool,
  render: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  selectedKey: PropTypes.string,
};

export default List;
